import type { ReactNode } from 'react'
import { Button, Menu, Stack } from '@mantine/core'
import { IconSettings, IconTrash } from '@tabler/icons-react'

interface OrderSettingsMenuProps {
  /**
   * Optional custom trigger element
   */
  renderTrigger?: (props: { onClick: () => void }) => ReactNode
  // /**
  //  * Optional callback for report driver action
  //  */
  // onReportDriver?: () => void
  /**
   * Optional callback for cancel order action
   */
  onCancelOrder?: () => void
  /**
   * Optional position for the dropdown menu
   * @default 'bottom-end'
   */
  position?: 'bottom-end' | 'bottom-start' | 'top-end' | 'top-start'
}

/**
 * A reusable settings menu component for order actions
 */
export function OrderSettingsMenu({
  renderTrigger,
  // onReportDriver,
  onCancelOrder,
  position = 'bottom-end',
}: OrderSettingsMenuProps) {
  // const handleReportDriver = () => {
  //   if (onReportDriver) {
  //     onReportDriver()
  //   }
  // }

  const handleCancelOrder = () => {
    if (onCancelOrder) {
      onCancelOrder()
    }
  }

  return (
    <Menu
      position={position}
      id="order-settings-menu"
      shadow="md"
      radius="md"
      withArrow
      styles={{
        dropdown: {
          backgroundColor: 'var(--mantine-color-white)',
          border: '1px solid var(--mantine-color-gray-3)',
        },
        arrow: {
          border: '1px solid var(--mantine-color-gray-3)',
        },
      }}
    >
      <Menu.Target>
        {renderTrigger ? (
          renderTrigger({ onClick: () => {} })
        ) : (
          <Button
            variant="subtle"
            color="gray.8"
            size="md"
            radius="md"
            leftSection={<IconSettings size={24} />}
          >
            Options
          </Button>
        )}
      </Menu.Target>
      <Menu.Dropdown>
        <Stack gap="xs">
          {/* TODO: Implement report driver in future work */}
          {/* <Menu.Item
            leftSection={<IconFileReport size={16} />}
            onClick={handleReportDriver}
            py="xs"
            fw={500}
          >
            Report driver
          </Menu.Item> */}
          <Menu.Item
            leftSection={<IconTrash size={16} color="var(--mantine-color-red-6)" />}
            color="red"
            onClick={handleCancelOrder}
            py="xs"
            fw={500}
          >
            Cancel order
          </Menu.Item>
        </Stack>
      </Menu.Dropdown>
    </Menu>
  )
}
